<template>
  <div id="">
    <v-toolbar
      id="header-remuneraciones"
      dense
      color="secondary darken-3"
      flat
      dark
      class="d-print-none"
    >
      <v-toolbar-items>
        <v-btn
          v-show="optionTimeSelected.var == 'mensual'"
          text
          icon
          color="white"
          :disabled="loading"
          @click="moveMonth(-1)"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>

        <v-btn
          v-show="optionTimeSelected.var == 'mensual'"
          text
          icon
          color="white"
          :disabled="loading"
          @click="moveMonth(1)"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <div v-show="optionTimeSelected.var == 'mensual'">
          <v-menu
            v-model="dateMenuMonth"
            offset-y
            :close-on-content-click="false"
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="white"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ dateMonthFormated }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="dates.dateMonth"
              color="primary"
              :disabled="loading"
              no-title
              type="month"
              locale="es-cl"
              @change="selectMonth()"
            />
          </v-menu>
        </div>

        <div v-show="optionTimeSelected.var == 'temporada'">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="loading"
                class="d-none d-md-flex"
                text
                v-on="on"
              >
                {{ periodoSelected.label || "periodo" }}
                <v-icon right>
                  arrow_drop_down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(periodo, index) in periodos"
                :key="'p-' + index"
                @click="
                  periodoSelected = periodo;
                  getData();
                "
              >
                <v-list-item-title>{{ periodo.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div v-show="optionTimeSelected.var == 'fechas'">
          <v-menu
            v-model="dateMenuIni"
            offset-y
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="white"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ dates.dateInicioFormatedReadeable }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="dates.dateInicioFormated"
              color="primary"
              no-title
              locale="es-cl"
              @change="changeDates()"
            />
          </v-menu>
        </div>

        <div v-show="optionTimeSelected.var == 'fechas'">
          <v-menu
            v-model="dateMenuFin"
            offset-y
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="white"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ dates.dateFinFormatedReadeable }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="dates.dateFinFormated"
              color="primary"
              no-title
              locale="es-cl"
              @change="changeDates()"
            />
          </v-menu>
        </div>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-show="!isMobile" text :disabled="loading" v-on="on">
              {{ optionTimeSelected.label }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in optionsTime"
              :key="index"
              @click="changeOptionTime(item)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-divider v-show="!isMobile" color="white" vertical inset />

        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-show="!isMobile" text :disabled="loading" v-on="on">
              Filtros
            </v-btn>
          </template>

          <v-card>
            <v-container>
              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <v-subheader>Dia</v-subheader>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="filter.dia"
                    :items="filter.diaOptions"
                    :disabled="loading"
                    item-text="label"
                    return-object
                    label="tipo tarjas"
                    single-line
                  />
                </v-col>
              </v-row>

              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <v-subheader>Tipo Trabajador</v-subheader>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="filter.tipoTrabajador"
                    :items="filter.tipoTrabajadorOptions"
                    item-text="label"
                    :disabled="loading"
                    label="tipo trabajador"
                    return-object
                    single-line
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-menu>

        <div>
          <div v-if="filter.dia.value > -1" class="tag">
            <span>
              {{ filter.dia.label }}
            </span>
          </div>

          <div v-if="filter.tipoTrabajador.value != 'todos'" class="tag">
            <span>
              {{ filter.tipoTrabajador.label }}
            </span>
          </div>
        </div>
      </v-toolbar-items>

      <v-spacer />

      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :small="isMobile"
              class="pr-xs-2 pr-lg-0"
              text
              icon
              color="white"
              :disabled="
                loading ||
                  dataTable.data == undefined ||
                  dataTable.data.length == 0
              "
              @click="print()"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :small="isMobile"
              text
              icon
              color="white"
              :disabled="
                loading ||
                  dataTable.data == undefined ||
                  dataTable.data.length == 0
              "
              @click="downloadXls()"
            >
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </template>
          <span>Descargar Excel</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <v-card class="d-print-none pa-1">
      <v-row align="center" dense>
        <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
            v-model="v1t"
            class="has-append-btn"
            height="20"
            :items="variablesTable"
            return-object
            :disabled="loading"
            single-line
            hide-details
            item-text="label"
            dense
            outlined
            tile
          >
            <template v-slot:append-outer>
              <div class="d-flex">
                <selector
                  v-model="v1t.filter.selected"
                  label="v1"
                  :title="v1t.label"
                  :item-children="v1t.itemChildren"
                  :items="v1t.filter.items"
                >
                  <template v-slot:button="{ on, selected }">
                    <v-btn
                      outlined
                      tile
                      height="40"
                      :disabled="v1t == nullItem || loading"
                      v-on="on"
                    >
                      <v-badge
                        bordered
                        color="green"
                        :value="v1t.filter.selected.length"
                        :content="v1t.filter.selected.length"
                      >
                        <v-icon>mdi-filter</v-icon>
                      </v-badge>
                    </v-btn>
                  </template>
                </selector>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </template>
          </v-select>
        </v-col>

        <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
            v-model="v2t"
            class="has-append-btn"
            :items="variablesTable"
            return-object
            :disabled="loading"
            single-line
            hide-details
            item-text="label"
            dense
            outlined
          >
            <template v-slot:append-outer>
              <div class="d-flex">
                <selector
                  v-model="v2t.filter.selected"
                  label="v2"
                  :title="v2t.label"
                  :item-children="v2t.itemChildren"
                  :items="v2t.filter.items"
                >
                  <template v-slot:button="{ on, selected }">
                    <v-btn
                      outlined
                      tile
                      height="40"
                      :disabled="v2t == nullItem || loading"
                      v-on="on"
                    >
                      <v-badge
                        bordered
                        color="deep-purple"
                        :value="v2t.filter.selected.length"
                        :content="v2t.filter.selected.length"
                      >
                        <v-icon>mdi-filter</v-icon>
                      </v-badge>
                    </v-btn>
                  </template>
                </selector>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </template>
          </v-select>
        </v-col>

        <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
            v-model="v3t"
            class="has-append-btn"
            :items="variablesTableAndNull"
            return-object
            :disabled="loading"
            single-line
            hide-details
            item-text="label"
            dense
            outlined
          >
            <template v-slot:append-outer>
              <div class="d-flex">
                <selector
                  v-model="v3t.filter.selected"
                  label="v3"
                  :title="v3t.label"
                  :item-children="v3t.itemChildren"
                  :items="v3t.filter.items"
                >
                  <template v-slot:button="{ on, selected }">
                    <v-btn
                      outlined
                      tile
                      height="40"
                      :disabled="v3t == nullItem || loading"
                      v-on="on"
                    >
                      <v-badge
                        bordered
                        color="teal"
                        :value="v3t.filter.selected.length"
                        :content="v3t.filter.selected.length"
                      >
                        <v-icon>mdi-filter</v-icon>
                      </v-badge>
                    </v-btn>
                  </template>
                </selector>
              </div>
            </template>
          </v-select>
        </v-col>

        <v-spacer />

        <v-col xs="12" md="auto">
          <v-select
            v-model="campoSelected"
            style="max-width: 200px"
            outlined
            dense
            hide-details
            :disabled="loading"
            item-text="label"
            return-object
            :items="camposOptions"
            label="Campos"
          />
        </v-col>

        <v-col xs="12" lg="auto">
          <v-btn
            :disabled="verifyVarHeader()"
            color="accent"
            @click="getData()"
          >
            cargar
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear
        color="accent"
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
      />
    </v-card>

    <div class="d-print-flex d-none justify-space-between header-print">
      <div>
        Árbol: {{ v1t.label }} > {{ v2t.label }}
        {{ v3t.varName ? "> " + v3t.label : "" }}
        <br />
        <span v-show="camposOptions.length > 2 || campoSelected !== nullItem">
          Campo: {{ campoSelected.label }}
        </span>
      </div>
      <div v-show="optionTimeSelected.var == 'mensual'">
        Mes: {{ dateMonthFormatedPrint }}
      </div>
      <div v-show="optionTimeSelected.var == 'temporada'">
        Temporada: {{ periodoSelected.label }}
      </div>
      <div v-show="optionTimeSelected.var == 'fechas'">
        Desde: {{ dates.dateInicioFormatedReadeable }}
        <br />
        Hasta: {{ dates.dateFinFormatedReadeable }}
      </div>

      <div>
        <div v-if="filter.dia.value > -1" class="tag tag-print">
          <span>
            {{ filter.dia.label }}
          </span>
        </div>

        <div
          v-if="filter.tipoTrabajador.value != 'todos'"
          class="tag tag-print"
        >
          <span>
            {{ filter.tipoTrabajador.label }}
          </span>
        </div>
      </div>
    </div>

    <v-row align="center" no-gutters>
      <v-col cols="12">
        <libro-remuneraciones-clon
          :key="dates.dateInicio.unix() + '_libro-remuneraciones'"
          :ref="dates.dateInicio.unix() + '_libro-remuneraciones'"
          :dates="dates"
          :data-table="dataTable"
          :contratistas="contratistas"
          :trabajadores="trabajadores"
          @change="getData()"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import campoModel from "@/models/campoModel";
import trabajadorModel from "@/models/trabajadorModel";
import contratistaModel from "@/models/contratistaModel";
import centrosCostoModel from "@/models/centrosCostoModel";
import laborModel from "@/models/laborModel";
import subLaborModel from "@/models/subLaborModel";
import libroRemuneracionesClon from "@/views/libroRemuneracionesClon";
import Repository from "@/models/repoIrricrops";
import selector from "@/components/selector";

export default {
  name: "Remuneraciones",
  components: {
    selector,
    libroRemuneracionesClon
  },
  data: () => ({
    trabajadores: [],
    contratistas: [],
    labores: [],
    laboresParsed: [],
    subLabores: [],
    centrosCosto: [],
    dataTable: {},
    loading: true,
    dates: {
      dateInicio: moment().startOf("month"),
      dateFin: moment().endOf("month"),
      dateInicioFormated: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      dateFinFormated: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      dateInicioFormatedReadeable: moment()
        .startOf("month")
        .format("DD MMM YY"),
      dateFinFormatedReadeable: moment()
        .endOf("month")
        .format("DD MMM YY"),
      dateMonth: moment()
        .startOf("month")
        .format("YY-MM")
    },
    dateMenuMonth: false,
    dateMenuIni: false,
    dateMenuFin: false,
    variable: null,
    optionTimeSelected: null,
    optionsTime: [
      { label: "Mensual", var: "mensual" },
      { label: "Temporada", var: "temporada" },
      { label: "Entre fechas", var: "fechas" }
    ],

    periodos: [
      {
        label: "2017-2018",
        init: "2017-05-01",
        end: "2018-04-30"
      },
      {
        label: "2018-2019",
        init: "2018-05-01",
        end: "2019-04-30"
      },
      {
        label: "2019-2020",
        init: "2019-05-01",
        end: "2020-04-30"
      },
      {
        label: "2020-2021",
        init: "2020-05-01",
        end: "2021-04-30"
      },
      {
        label: "2021-2022",
        init: "2021-05-01",
        end: "2022-04-30"
      },
      {
        label: "2022-2023",
        init: "2022-05-01",
        end: "2023-04-30"
      },
      {
        label: "2023-2024",
        init: "2023-05-01",
        end: "2024-04-30"
      }
    ],

    periodoSelected: null,

    selected: [],

    dia: true,
    trato: false,
    contratista: false,

    variablesTable: [
      {
        label: "Labor",
        itemChildren: "subLabores", // para vista de arbol, con nombre de hijos variables
        treeName: "labor",
        varName: ["labor", "sub_labor"],
        paramFilterName: "sub_labores_id",
        showOptionalData: [false, true], // para mostrar total, pero se activa en la tabla como cascada
        filter: { items: [], selected: [] }
      },
      {
        label: "Centro de costo",
        itemChildren: "",
        treeName: "centro_costo",
        paramFilterName: "centros_costo_id",
        varName: "centros_costo",
        showOptionalData: [false],
        filter: { items: [], selected: [] }
      },
      {
        label: "Trabajador",
        itemChildren: "",
        treeName: "trabajador",
        paramFilterName: "trabajadores_id",
        varName: "trabajador",
        showOptionalData: [false],
        filter: { items: [], selected: [] }
      }
    ],

    variablesTableAndNull: null,

    v1t: null,
    v2t: null,
    v3t: null,

    campos: [],
    camposOptions: [],
    campoSelected: null,
    camposMenu: false,
    nullItem: {
      label: "- No Asignado -",
      //active  : true,
      treeName: null,
      varName: null,
      filter: { items: [], selected: [] }
    },

    filter: {
      dia: null,
      diaOptions: [
        {
          label: "Todos",
          value: -1
        },
        {
          label: "Dia",
          value: 1
        },
        {
          label: "Trato",
          value: 0
        },
        {
          label: "Dia + Trato",
          value: 2
        }
      ],

      tipoTrabajador: null,
      tipoTrabajadorOptions: [
        {
          label: "Todos",
          value: "todos"
        },
        {
          label: "Contratista",
          value: "contratista"
        },
        {
          label: "Sin Contratistas",
          value: "sin_contratista"
        }
      ]
    }
  }),
  computed: {
    empresaSelected() {
      return this.$store.getters.empresaSelected;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    dateMonthFormated() {
      return moment(this.dates.dateMonth + "-01", "YY-MM-DD").format("MMM");
    },
    dateMonthFormatedPrint() {
      return moment(this.dates.dateMonth + "-01", "YY-MM-DD").format(
        "MMMM YYYY"
      );
    }
  },
  watch: {
    empresaSelected() {
      this.clearFilters();
      this.getBaseData();
    }
  },
  mounted() {
    this.clearFilters();
    this.getBaseData();
  },
  created() {
    this.optionTimeSelected = this.optionsTime[0];
    this.periodoSelected = _.nth(this.periodos, 3);
    this.variablesTableAndNull = this.variablesTable.concat([this.nullItem]);
    this.v1t = this.variablesTable[0];
    this.v2t = this.variablesTable[1];
    this.v3t = this.variablesTableAndNull[3];
    this.campoSelected = this.nullItem;
    this.filter.dia = _.first(this.filter.diaOptions);
    this.filter.tipoTrabajador = _.first(this.filter.tipoTrabajadorOptions);
  },
  methods: {
    getData() {
      this.loading = true;
      var self = this;
      var arbol = [this.v1t.treeName, this.v2t.treeName];

      if (this.v3t && this.v3t.treeName) {
        arbol.push(this.v3t.treeName);
      }
      arbol = arbol.join(",");

      var params = {
        empresa_id: this.empresaSelected.id,
        fecha_inicio: this.dates.dateInicioFormated,
        fecha_fin: this.dates.dateFinFormated,
        arbol: arbol
        //tipo_trabajador : this.filter.tipoTrabajador,
        //dia             : this.filter.dia
      };

      if (this.filter.tipoTrabajador.value != "todos") {
        params.tipo_trabajador = this.filter.tipoTrabajador.value;
      }

      if (this.filter.dia.value >= 0) {
        params.dia = this.filter.dia.value;
      }

      if (this.campoSelected.val !== null) {
        params.campos_id = [this.campoSelected.val.id];
      }

      this.variablesTable.forEach(varTable => {
        if (varTable.filter.selected.length > 0) {
          params[varTable.paramFilterName] = varTable.filter.selected.map(
            s => s.id
          );
        }
      });

      Repository.get("/presupuesto/real/", { params })
        .then(
          response => {
            self.loading = false;
            self.parseData(response.data.data);
          },
          function(resError) {
            self.loading = false;
            console.error(resError);
            console.log("FAILURE!!");
          }
        )
        .catch(error => {
          console.error(error);
          console.log("error occured");
        });
    },

    parseData(data) {
      var vars = _.flattenDeep([
        this.v1t.varName,
        this.v2t.varName,
        this.v3t.varName
      ]);
      this.vars = vars;

      var varShowOptionalData = _.flattenDeep([
        this.v1t.showOptionalData,
        this.v2t.showOptionalData,
        this.v3t.showOptionalData
      ]);

      var cascadeIsActive = false;

      varShowOptionalData = _.map(varShowOptionalData, v => {
        cascadeIsActive = cascadeIsActive || v;
        return cascadeIsActive;
      });

      /**
        parsea los datos de data ,
        recorriendo segun el arbol de variables en vars
        vars[0] --> primer nodo del arbol

        TODO: hacer profundidad del arbol variable,
              no importante, pero si perfectible
      */

      var dataParsed = _.map(data[vars[0]], d => {
        d.showOptionalData = varShowOptionalData[0];
        d.clickItem = {};
        d.clickItem[vars[0]] = d.id;

        d.children = _.map(d[vars[1]], d2 => {
          d2.showOptionalData = varShowOptionalData[1];
          d2.clickItem = { ...d.clickItem };
          d2.clickItem[vars[1]] = d2.id;

          d2.children = _.map(d2[vars[2]], d3 => {
            d3.showOptionalData = varShowOptionalData[2];
            d3.clickItem = { ...d2.clickItem };
            d3.clickItem[vars[2]] = d3.id;

            d3.children = _.map(d3[vars[3]], d4 => {
              d4.showOptionalData = varShowOptionalData[3];
              d4.clickItem = { ...d3.clickItem };
              d4.clickItem[vars[3]] = d4.id;
              return d4;
            });
            return d3;
          });
          return d2;
        });
        return d;
      });

      this.dataTable = {
        title: "a title table",
        data: dataParsed,
        vars: vars,
        totales: data.total || null
      };
    },

    moveMonth(cant) {
      this.dates.dateInicio = this.dates.dateInicio.add(cant, "month");
      this.dates.dateFin = this.dates.dateFin.add(cant, "month").endOf("month");
      this.dates.dateMonth = moment(this.dates.dateMonth + "-01", "YY-MM-DD")
        .add(cant, "month")
        .format("YY-MM");

      this.dates.dateInicioFormated = this.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      this.dates.dateFinFormated = this.dates.dateFin.format("YYYY-MM-DD");
    },

    selectMonth() {
      this.dates.dateInicio = moment(this.dates.dateMonth + "-01", "YY-MM-DD");
      this.dates.dateFin = moment(
        this.dates.dateMonth + "-01",
        "YY-MM-DD"
      ).endOf("month");
      this.dates.dateInicioFormated = this.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      this.dates.dateFinFormated = this.dates.dateFin.format("YYYY-MM-DD");
      this.dateMenuMonth = false;
    },

    changeOptionTime(item) {
      this.optionTimeSelected = item;
      if (item.var == "mensual") {
        this.selectMonth();
        return;
      } else if (item.var == "temporda") {
        this.dates.dateInicio = moment(this.periodoSelected.init, "YYYY-MM-DD");
        this.dates.dateFin = moment(this.periodoSelected.end, "YYYY-MM-DD");
      } else {
        this.dates.dateInicio = new moment();
        this.dates.dateFin = new moment().add(7, "days");
      }
      this.dates.dateInicioFormated = this.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      this.dates.dateFinFormated = this.dates.dateFin.format("YYYY-MM-DD");
      this.dates.dateInicioFormatedReadeable = this.dates.dateInicio.format(
        "DD MMM YY"
      );
      this.dates.dateFinFormatedReadeable = this.dates.dateFin.format(
        "DD MMM YY"
      );
    },

    changeDates() {
      this.dates.dateInicio = moment(this.dates.dateInicioFormated);
      this.dates.dateFin = moment(this.dates.dateFinFormated);
      this.dates.dateInicioFormatedReadeable = this.dates.dateInicio.format(
        "DD MMM YY"
      );
      this.dates.dateFinFormatedReadeable = this.dates.dateFin.format(
        "DD MMM YY"
      );
    },

    clearFilters() {
      this.variablesTable.forEach(v => {
        v.filter.selected = [];
      });
    },
    getBaseData() {
      this.loading = true;
      var promises = [
        this.getCampos(),
        this.getTrabajadores(),
        this.getContratistas(),
        this.getLabores(),
        this.getSubLabores(),
        this.getCentrosCosto()
      ];
      return Promise.all(promises).then(
        () => {
          this.laboresParsed = this.parseLabores();
          this.loading = false;
        },
        resError => {
          console.error(resError);
          this.loading = false;
        }
      );
    },

    parseLabores() {
      return _.map(this.labores, l => {
        l.subLabores = this.subLabores[l.id];
        return l;
      });
    },

    getCampos() {
      if (this.empresaSelected == null) return;
      return campoModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.campos = res.data.data;
            this.camposOptions = _.map(this.campos, c => {
              return {
                val: c,
                label: c.nombre
              };
            });
            this.camposOptions.unshift({
              val: null,
              label: "Todos los Campos"
            });
            this.campoSelected = _.first(this.camposOptions);
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getTrabajadores() {
      if (this.empresaSelected == null) return;
      return trabajadorModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.trabajadores = res.data.data;
            _.forEach(this.trabajadores, tr => {
              tr.codname = tr.nombre;
              if (tr.codigo && tr.codigo.length > 1) {
                tr.codname = tr.codigo;
              }
              this.variablesTable[2].filter.items = this.trabajadores;
            });
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getContratistas() {
      if (this.empresaSelected == null) return;

      return contratistaModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.contratistas = res.data.data;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getLabores() {
      if (this.empresaSelected == null) return;

      return laborModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.labores = res.data.data;
            this.variablesTable[0].filter.items = this.labores;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getSubLabores() {
      if (this.empresaSelected == null) return;

      return subLaborModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.subLabores = res.data.data; //_.flatMap(res.data.data, data=>data);
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getCentrosCosto() {
      if (this.empresaSelected == null) return;

      return centrosCostoModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.centrosCosto = res.data.data;
            this.variablesTable[1].filter.items = this.centrosCosto;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    verifyVarHeader() {
      return !(
        this.v1t !== this.v2t &&
        this.v1t !== this.v2t &&
        this.v2t !== this.v3t
      );
    },

    print() {
      var containers = document.getElementsByClassName("container-tl");
      _.forEach(containers, c => {
        c.scrollLeft = 0;
      });
      window.print();
    },

    selectCampo(campo) {
      this.campoSelected = campo;
    },

    alert(text) {
      alert(text);
    },

    downloadXls() {
      var ref = this.dates.dateInicio.unix() + "_libro-remuneraciones";
      this.$refs[ref].downloadXls("Analisis");
    }
  }
};
</script>
<style lang="scss" scoped>
.tag {
  border-radius: 5px;
  background: red;
  margin: 12px 16px;
  padding: 0px 12px;
  font-size: 14px;
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #0d47a1; //900
  background: #42a5f5; // 400
  color: #0d47a1; // 900
  &.tag-print {
    margin: 0px 4px;
  }
}
.header-print {
  margin: 8px 8px 16px 8px;
}
</style>
